import { useMemo } from 'react';

import { type useBuildFormContext } from '../../../form/schema';
import { type BuildQuizListItem } from '../../../form/schema/BuildQuizListSchema';
import { type AiBuilderSelectedQuizContext } from '../stores/types';

type UseAiBuilderSelectedQuizContextParams = {
  editingQuizId: string | null | undefined;
  getValues: ReturnType<typeof useBuildFormContext>['getValues'];
  isGenerating: boolean;
  quizList: BuildQuizListItem[];
  turnInProgress: boolean;
};

export const useAiBuilderSelectedQuizContext = ({
  editingQuizId,
  getValues,
  isGenerating,
  quizList,
  turnInProgress,
}: UseAiBuilderSelectedQuizContextParams) => {
  return useMemo<AiBuilderSelectedQuizContext | null>(() => {
    if (!editingQuizId || isGenerating || turnInProgress) {
      return null;
    }

    const quizIndex = quizList.findIndex(quiz => quiz.id === editingQuizId);
    if (quizIndex === -1) return null;

    const quiz = getValues(`quizList.${quizIndex}`);

    return {
      id: editingQuizId,
      number: quizIndex + 1,
      question: quiz?.question?.trim() ?? '',
    };
  }, [editingQuizId, getValues, isGenerating, quizList, turnInProgress]);
};
